module.exports = __webpack_public_path__ + "static/img/er.9508c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/er.png
// module id = xKuS
// module chunks = 0